import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import api from "../../util/api";

const initialState = {
  getMapCoord: {
    loading: false,
    firstRouteData: [],
    secondRouteData: [],
    firstData: [],
    secondData: [],
    FirstExportData: [],
    SecondExportData: [],
    ErrorFirst: "",
    ErrorSecond: "",
    routeData: {},
  },
};

//Relay API call
const asyncGetMapCoord = createAsyncThunk(
  "relay/getMapCoord",
  async (payload, { rejectWithValue }) => {
    const {
      id,
      routeType = "Practical",
      roadNetwork = "State + National Network",
      roads = "Highways & Streets",
      tollRoads = "Discouraged",
      internationalBorders = "Open",
      restrictions = "Use",
      ferries = "Discouraged",
      hubRouting = "Disabled",
      sideOfStreetAdherence = "Off",
      governorSpeedLimit = "Enabled",
      governorSpeedLimitMPH = "55",
      elevation = "Any",
      elevationFT = "7500",
      hazmat = "None",
      siteRouting = "Disabled",
      terminalMaxDistance = "600",
      pilotMaxDistance = "350",
      terminalMaxHours = "11",
      vehicleType = "Truck",
      height,
      length,
      width = "96",
      weight = "80000",
      axies = "5",
      multipleTrailer = false,
    } = payload;
    const encodeRoads = encodeURIComponent(roads);
    const encodeRoadNetwork = encodeURIComponent(roadNetwork);
    try {
      const response = await api.get(
        `api/relays/${id}?routeType=${routeType}&roadNetwork=${encodeRoadNetwork}&roads=${encodeRoads}&avoidTolls=${tollRoads}&internationalBorders=${internationalBorders}&restrictions=${restrictions}&inclFerryDist=${ferries}&hubRouting=${hubRouting}&sideOfStreetAdherence=${sideOfStreetAdherence}&governorSpeedLimit=${governorSpeedLimit}&governorSpeedLimitMPH=${governorSpeedLimitMPH}&elevation=${elevation}&elevationFT=${elevationFT}&hazmat=${hazmat}&siteRouting=${siteRouting}&terminalMaxDistance=${terminalMaxDistance}&pilotMaxDistance=${pilotMaxDistance}&terminalMaxHours=${terminalMaxHours}&vehType=${vehicleType}&vehHeight=${height}&vehLength=${length}&vehWidth=${width}&vehWeight=${weight}&axles=${axies}&multipleTrailer=${multipleTrailer}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

export const relaySlice = createSlice({
  name: "relay",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get map coord
    builder.addCase(asyncGetMapCoord.pending, (state) => {
      state.getMapCoord = {
        loading: true,
        firstRouteData: [],
        secondRouteData: [],
        firstData: [],
        secondData: [],
        FirstExportData: [],
        SecondExportData: [],
        ErrorFirst: "",
        ErrorSecond: "",
        routeData:{}
      };
    });
    builder.addCase(asyncGetMapCoord.fulfilled, (state, action) => {
      state.getMapCoord = {
        loading: false,
        firstRouteData:
          action.payload.data.output?.map((item) => [
            item.latitude,
            item.longitude,
          ]) || [],
        secondRouteData:
          action.payload.data.outputSecond?.map((item) => [
            item.latitude,
            item.longitude,
          ]) || [],
        firstData: action.payload.data.output || [],
        secondData: action.payload.data.outputSecond || [],
        FirstExportData: action.payload.data.export || [],
        SecondExportData: action.payload.data.exportSecond || [],
        ErrorFirst: action.payload.data.error || "",
        ErrorSecond: action.payload.data.errorSecond || "",
        routeData:action.payload.data.resultRoute || {}
      };
    });
    builder.addCase(asyncGetMapCoord.rejected, (state) => {
      state.getMapCoord = {
        loading: false,
        firstRouteData: [],
        secondRouteData: [],
        firstData: [],
        secondData: [],
        FirstExportData: [],
        SecondExportData: [],
        ErrorFirst: "",
        ErrorSecond: "",
        routeData:{}
      };
    });
  },
});

export { asyncGetMapCoord };

export default relaySlice.reducer;
